import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Hero.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/homePage/NextGames.jsx");
